import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";
import {
  MediaConversionStatusResponseDto,
  MediaEducationalPathResponseDto,
} from "../../interfaces/media";

export const mediaApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMediaConversionStatus: builder.query<
      MediaConversionStatusResponseDto,
      PaginateQuery
    >({
      query: (data) => ({
        url: buildPaginationQueryString(data, "/api/media/conversion-status"),
      }),
      providesTags: ["Media"],
    }),
    getMediaEducationalPath: builder.query<
      MediaEducationalPathResponseDto,
      string
    >({
      query: (id) => ({
        url: `/api/media/educational-path/${id}`,
      }),
    }),
    updateMediaStatus: builder.mutation<any, { id: string; status: string }>({
      query: ({ id, status }) => ({
        url: `/api/media/${id}/change-status/${status}`,
        method: "PATCH",
        body: null,
      }),
      invalidatesTags: ["Media", "LiveLecture"],
    }),
    setMediaNeedsReconversion: builder.mutation<
      boolean,
      { id: string; needsReconversion: boolean }
    >({
      query: ({ id, needsReconversion }) => ({
        url: `/api/media/${id}/needs-reconversion/${needsReconversion}`,
        method: "PATCH",
        body: null,
      }),
      invalidatesTags: ["Media"],
    }),
    setMediaReprocessingPriority: builder.mutation<
      boolean,
      { id: string; priority: boolean }
    >({
      query: ({ id, priority }) => ({
        url: `/api/media/${id}/reprocessing-priority/${priority}`,
        method: "PATCH",
        body: null,
      }),
      invalidatesTags: ["Media"],
    }),
    skipMediaReprocessing: builder.mutation<boolean, string>({
      query: (id) => ({
        url: `/api/media/${id}/skip-reprocessing`,
        method: "PATCH",
        body: null,
      }),
      invalidatesTags: ["Media"],
    }),
  }),
});

export const {
  useGetMediaConversionStatusQuery,
  useGetMediaEducationalPathQuery,
  useUpdateMediaStatusMutation,
  useSetMediaNeedsReconversionMutation,
  useSetMediaReprocessingPriorityMutation,
  useSkipMediaReprocessingMutation,
} = mediaApi;
